<template>
  <div>
    <StepHeader
      :title="title"
    />

    <StepContent
      width="md"
    >
      <AppInput
        label="Years"
        horizontal
        placeholder="0"
        type="tel"
        pattern="\d*"
        :value="address_years"
        name="address_years"
        :error="addressYearsError"
        v-data-layer
        data-layer="address_years_field"
        @input="handleInput('address_years', $event)"
      />
      <AppInput
        label="Months"
        horizontal
        type="tel"
        pattern="\d*"
        placeholder="0"
        name="address_months"
        :value="address_months"
        :error="addressMonthsError"
        v-data-layer
        data-layer="address_months_field"
        @input="handleInput('address_months', $event)"
      />
    </StepContent>

    <StepFooter>
      <AppButtonContinue
        v-data-layer="handleDataLayer"
        @click="handleContinue()"
      >
        Continue
      </AppButtonContinue>

      <StepTooltip>
        If you just moved in please enter 1 month to continue.
      </StepTooltip>
    </StepFooter>
  </div>
</template>

<script>
import AppButtonContinue from '@/components/common/buttons/AppButtonContinue'
import AppInput from '../inputs/AppInput'
import StepContent from '@/components/common/step/StepContent'
import StepFooter from '@/components/common/step/StepFooter'
import StepHeader from '@/components/common/step/StepHeader'
import StepTooltip from '@/components/common/step/StepTooltip'
import DataLayer from '../../../../data-layer'

export default {
  // Name
  name: 'address-duration',

  // Components
  components: {
    AppButtonContinue,
    AppInput,
    StepContent,
    StepFooter,
    StepHeader,
    StepTooltip
  },

  // Data
  data () {
    return {
      datalayerStepName: 'address_time',
      submitted: false,
      title: 'How Long Have You Lived at Your Current Address?'
    }
  },

  // Computed
  computed: {
    address_years () {
      return this.$store.state.application.address_years
    },

    address_months () {
      return this.$store.state.application.address_months
    },

    addressYearsError () {
      if (!this.submitted) return ''
      if (!+this.address_years && !+this.address_months) {
        return 'Entry cannot be 0 years and 0 months.'
      }
      if (!this.isValidNumber(this.address_years)) {
        return 'Please enter a valid number'
      }
      if (this.address_years > 99) return 'Cannot exceed 99.'
      if (this.address_years < 0) return 'Please enter a value greater than or equal to 0.'
    },

    addressMonthsError () {
      if (!this.submitted) return ''
      if (!+this.address_years && !+this.address_months) {
        return 'Enter \'1\' month if you just moved'
      }
      if (!this.isValidNumber(this.address_months)) return 'Please enter a valid number'
      if (this.address_months < 0) return 'Please enter a value greater than or equal to 0.'
      if (this.address_months > 11) return 'Cannot exceed 11.'
    },

    stepIsValid () {
      return !this.addressYearsError && !this.addressMonthsError
    }
  },

  // Methods
  methods: {
    handleInput (field, value) {
      this.$store.updateApplication(field, +value || value)
    },

    isValidNumber (value) {
      if (!value) {
        value = 0
      }
      return /^\d+$/.test(value.toString().trim() || 0)
    },

    handleContinue () {
      this.submitted = true
      if (!this.addressYearsError && !this.addressMonthsError) {
        if (!this.address_months || !this.address_months.toString().trim()) {
          this.handleInput('address_months', 0)
        }
        if (!this.address_years || !this.address_years.toString().trim()) {
          this.handleInput('address_years', 0)
        }
        this.$emit('next')
      }
    },

    handleDataLayer () {
      DataLayer.track({
        event: 'gpa_step_completed',
        step: '12',
        address_time: this.address_years
      })
    }
  }
}
</script>

<style scoped lang="scss">
.step-content {

  @include breakpoint('desktop-up') {
    height: 370px;
  }
}
</style>
